import Logo from "@/app/(components)/generics/Logo/Logo";

import { DefaultProps } from "@/app/types/DefaultProps";
import styles from "./PageLoader.module.css";

type Props = DefaultProps & {};
export default function PageLoader(_props: Props) {
  return (
    <div className={styles.container}>
      <Logo max blinker />

      {/*
			<p>{ UTrans.T(TranslationsKey.LOADING, props.params.lang) }...</p>
			*/}
    </div>
  );
}
